export const EcgLine = ({ className = "text-gold" }) => (
  <svg
    viewBox="0 0 600 60"
    fill="none"
    preserveAspectRatio="none"
    className={className}
    aria-hidden="true"
  >
    <path
      className="ecg-path"
      d="M0 30 H110 l8 -10 8 10 h34 l10 -24 12 38 10 -14 h44 l6 -6 6 6 h64 l8 -16 10 24 8 -8 h52 l7 -9 7 9 h60 l9 -13 11 20 8 -7 h96"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
      strokeLinecap="round"
    />
  </svg>
);
